import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped module
import { useParentAppName } from '../../../hooks/searchParamHooks';
import { appendQueryParams } from '../../../utils/urls';
import { useLesson, useShorts } from '../../../hooks/contentHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcademyRedirectLink = ({
  link,
  lessonId,
  shortId,
  contentId,
  onClick,
  isPublic = false,
  openLinksInNewTab,
  linkTextProps
}) => {
  var _lesson$content;
  const {
    lesson
  } = useLesson(lessonId, isPublic);
  const {
    shortFormContent
  } = useShorts(shortId, isPublic);
  const videoName = contentId ? lesson === null || lesson === void 0 || (_lesson$content = lesson.content) === null || _lesson$content === void 0 || (_lesson$content = _lesson$content.find(content => content.id === contentId)) === null || _lesson$content === void 0 ? void 0 : _lesson$content.name : undefined;
  const shortFormName = shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.name;
  const videoOrLessonName = videoName || (lesson === null || lesson === void 0 ? void 0 : lesson.name);
  const name = shortFormName || videoOrLessonName;
  const parentAppName = useParentAppName();
  const href = appendQueryParams(link, {
    utm_source: parentAppName,
    utm_medium: 'embedded'
  });
  if (name === undefined) {
    return null;
  }
  const textProps = Object.assign({
    typography: 'link-25',
    paddingBlockStart: '100'
  }, linkTextProps);
  return /*#__PURE__*/_jsx(Text, Object.assign({}, textProps, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        UILink: Link
      },
      message: "academyAiPrompt.videoTitle_jsx",
      options: {
        videoTitle: name,
        href,
        onClick,
        testId: 'embedded-academy-redirect-link',
        external: openLinksInNewTab !== null && openLinksInNewTab !== void 0 ? openLinksInNewTab : true,
        target: openLinksInNewTab !== false ? '_blank' : '_top'
      }
    })
  }));
};